"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeHeatFilterDataModelFromDTO = exports.mapHeatFilterDataModelToDTO = exports.mapHeatFilterDatabaseModelToDataModel = exports.HeatFilterDataModelCodec = void 0;
const E = __importStar(require("fp-ts/Either"));
const function_1 = require("fp-ts/function");
const O = __importStar(require("fp-ts/Option"));
const t = __importStar(require("io-ts"));
const io_ts_types_1 = require("io-ts-types");
const heat_filter_1 = require("./heat-filter");
const validation_1 = require("@bloodline-packages/bloodline/dist/validation");
exports.HeatFilterDataModelCodec = t.type({
    id: io_ts_types_1.UUID,
    name: t.string,
    clientId: (0, io_ts_types_1.optionFromNullable)(io_ts_types_1.UUID),
    configuration: heat_filter_1.HeatFilterC,
    isPrivate: t.boolean,
    sqlConfiguration: (0, io_ts_types_1.optionFromNullable)(t.string),
});
const heatFilterDataModelEquals = true;
const heatFilterDataModelDTOEquals = true;
const mapHeatFilterDatabaseModelToDataModel = (filter) => ({
    id: filter.heat_filter_id,
    name: filter.name,
    clientId: O.fromNullable(filter.client_id),
    configuration: filter.configuration,
    // cronFrequency: filter.cron_frequency,
    isPrivate: filter.is_private,
    sqlConfiguration: O.fromNullable(filter.sql_configuration),
});
exports.mapHeatFilterDatabaseModelToDataModel = mapHeatFilterDatabaseModelToDataModel;
const mapHeatFilterDataModelToDTO = (filter) => (0, function_1.pipe)(filter, exports.HeatFilterDataModelCodec.encode);
exports.mapHeatFilterDataModelToDTO = mapHeatFilterDataModelToDTO;
const decodeHeatFilterDataModelFromDTO = (input) => (0, function_1.pipe)(input, exports.HeatFilterDataModelCodec.decode, E.mapLeft((0, validation_1.toValidationError)('Could not decode input in decodeHeatFilterScoreBatchDTO', input)));
exports.decodeHeatFilterDataModelFromDTO = decodeHeatFilterDataModelFromDTO;
//# sourceMappingURL=heat-filter-data-model.js.map